<template>
    <v-dialog v-model="dialog" max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn small color="secondary" class="mx-8 my-2 text-lowercase" fab v-on="on">
				{{ 'info' | localize }}
			</v-btn>
		</template>
		<v-card>
			<v-spacer></v-spacer>
			<v-card-title class="subtitle-2 pt-6 secondary--text">
				{{ 'Report information' | localize }}
			</v-card-title>
			<v-divider />
			<v-card-text class="text-justify black--text">
				{{ text }}
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
					{{ 'close' | localize }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
    props: ['text'],
    data() {
        return {
        dialog: false,
        }
   },
    methods: {
        closeDialog() {
            this.dialog = false;
        }
   }
}
</script>
<style scoped>
</style>